<div class="container-fuid bg-white default-boxrounded">
  <div class="col-12 w-100">
    <h3 class="title col-9">
      <span translate="Modals.EditRequest.Title"></span>
    </h3>
  </div>
  <div class="p-4 pt-0">
    <form class="row needs-validation has-validation" [formGroup]="form" (ngSubmit)="save()">
      <div class="mb-3">
        <label for="requestName" class="form-label" translate="Modals.EditRequest.RequestName"></label>
        <input type="text" id="requestName" formControlName="requestName" class="form-control" [value]="request.requestName" />
        <app-formcontrol-error-messages [forControl]="requestNameValue"></app-formcontrol-error-messages>
      </div>

      @if (changeWorkgroupAllowed()) {
        <div class="mb-3">
          <label for="workgroup" class="form-label" translate="Modals.EditRequest.Workgroup"></label>
          <div ngbDropdown class="dropdown" name="workgroup" id="workgroup">
            <button type="button" [attr.data-testid]="'workgroupDropdown'" class="btn workgroup dropdown-toggle text-truncate" id="dropdownMenu" ngbDropdownToggle>{{ newWorkgroupName ? newWorkgroupName : this.translations.NoWorkgroup }}
              <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu" data-testid="dropdownMenuWorkgroups">
              <button type="button" ngbDropdownItem value="" (click)="changeCurrentWorkgroup($event)" translate="requestoverview.DialogChangeWorkgroup.NoWorkgroup" [attr.data-testid]="'workgroup_0'"></button>
              @for (workgroup of workgroups; track workgroup; let i = $index) {
                <button type="button" ngbDropdownItem value="{{workgroup.guid}}" (click)="changeCurrentWorkgroup($event)" [attr.data-testid]="'workgroup_' + (i + 1)">{{workgroup.name}}</button>
              }
            </div>
          </div>
        </div>
        @if (maxWorkgroupClearanceLevel != 1) {
          <div class="mb-3">
            <label for="clearancelevel" class="form-label" translate="Modals.EditRequest.Clearancelevel"></label>
            <div ngbDropdown class="dropdown" name="clearancelevel" id="clearancelevel" >
              <button type="button" [attr.data-testid]="'clearancelevelDropdown'" class="btn workgroup dropdown-toggle text-truncate" type="button" id="dropdownMenu" ngbDropdownToggle>{{ newClearancelevel ? newClearancelevel : currentClearancelevel }}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownMenu" data-testid="dropdownMenuClearanceLevels">
                @for (j of counter(1, maxWorkgroupClearanceLevel); track j; let i = $index) {
                  <button ngbDropdownItem type="button" value={{j}} (click)="changeCurrentClearancelevel($event)" [attr.data-testid]="'clearancelevel_' + j">{{j}}</button>
                }
              </div>
            </div>
          </div>
        }
      }

      <!-- Display Auto export editor -->
      @if (autoExportEnabled) {
        <label class="form-label text-truncate d-block" translate="Request.RequestTitle.AutoExportTitle">
          <app-info-button labelName="Request.RequestTitle.AutoExportTooltip"></app-info-button>
        </label>
        <div class="input-group">
          <button type="button" class="btn btn-sm"
            [ngClass]="hasCloudItemSet ? 'btn-danger' : 'btn-primary'"
            (click)="hasCloudItemSet ? resetAutoExport() : openFolderSelection()">
            @if (!hasCloudItemSet) {
              <span
              translate="Button.SelectPath"></span>
            }
            @if (hasCloudItemSet) {
              <span
              translate="Button.ClearPath"></span>
            }
          </button>
          <input type="text" class="form-control" [value]="selectedfolderPath" readonly>
        </div>
      }

      <div class="col-12 mt-4 pb-2 d-table w-100">
        <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeModal()" translate="Button.Back"></button></span>
        <span class="float-end"><button type="submit" class="btn btn-sm btn-primary" translate="Button.Confirm"></button></span>
      </div>
    </form>
  </div>
</div>